import { combineReducers } from "redux";
import { getType, PayloadAction } from "typesafe-actions";
import { actions } from "..";
import { Actions, StoreState } from "../types";

function reduce<T extends Extract<Actions, PayloadAction<string, any>>['type'], P extends Extract<Actions, PayloadAction<T, any>>['payload']>(type: T) {
  return function reducer(state: P | null = null, action: Actions): P | null {
    switch (action.type) {
      case type:
        return action.payload as P | null
    }

    return state
  }
}

function showNoLicensesAvailable(state: boolean = false, action: Actions): boolean {
  switch  (action.type) {
    case getType(actions.showNoLicensesAvailable):
      return action.payload
  }
  return state
}

export default combineReducers({
  queueStats: reduce(getType(actions.openQueueStats)),
  agentStats: reduce(getType(actions.openAgentStats)),
  voiceMail: reduce(getType(actions.openVoiceMail)),
  showNoLicensesAvailable,
})

function getRoot(state: StoreState) { return state.modals }
export function selectQueueStatsModal(state: StoreState) { return getRoot(state).queueStats }
export function selectAgentStatsModal(state: StoreState) { return getRoot(state).agentStats }
export function selectVoiceMailModal(state: StoreState) { return getRoot(state).voiceMail }
export function selectShowNoLicensesAvailable(state: StoreState) { return getRoot(state).showNoLicensesAvailable }
